import { extend } from 'flarum/extend';
import DiscussionList from 'flarum/components/DiscussionList';
import DiscussionListItem from 'flarum/components/DiscussionListItem';

const stickiest_section_class = "stickiest-section-splitter";
let sortKey   = null;


//const reset_stickiest_section = function(sticky_class: string){
//  // Alle Elemente abrufen, die bereits die benutzerdefinierte Klasse haben, und diese Klasse entfernen
//  const all_stickiest_elements = document.querySelectorAll('.'+sticky_class);
//
//  $(".last-stickiest-section-item").removeClass("last-stickiest-section-item");
//  $(".first-li-after-stickiest-section").removeClass("first-li-after-stickiest-section");
//
//  let x = 0;
//  let abort_foreach = false;
//  let section_affected = false;
//  all_stickiest_elements.forEach(element => {
//      if(x === 0 && $(element).closest("li").prev().length > 0) {
//        abort_foreach = true;
//      }
//      //if(x < all_stickiest_elements.length -1 ) {
//      //  $(element).closest("li").removeClass(stickiest_section_class);
//      //} else {
//        if(!abort_foreach && (sortKey == undefined || sortKey == null)) {
//          section_affected = true;
//          $(element).closest("li").addClass(stickiest_section_class);
//          if(x == all_stickiest_elements.length -1) {
//            $(element).closest("li").addClass("last-stickiest-section-item");
//            $(element).closest("li").next().addClass("first-li-after-stickiest-section");
//          }
//        }
//      //  $(element).closest("li").removeClass(stickiest_section_class);
//      //} 
//      //}
//      x++;
//  });
//  return section_affected;
//}


const reset_stickiest_section = function(sticky_classes_string) {
  const sticky_classes = sticky_classes_string.split(' ').filter(Boolean);
  const container = document.querySelector('.DiscussionList-discussions');

  if (!container) {
    //console.error('Container not found');
    return [];
  }

  const listItems = container.querySelectorAll(':scope > li');
  let consecutive_elements = [];
  let section_affected = false;

  //console.info(listItems);

  for (let i = 0; i < listItems.length; i++) {
    const listItem = listItems[i];
    let hasStickyChild = false;

    // Überprüfen, ob eines der Kinder die sticky Klassen enthält
    for (let j = 0; j < sticky_classes.length; j++) {
      if (listItem.querySelector('.' + sticky_classes[j])) {
        hasStickyChild = true;
        break;
      }
    }

    if (hasStickyChild) {
      consecutive_elements.push(listItem);
    } else {
      break;
    }
  }

  //console.info(consecutive_elements);

  // Entferne spezifische Klassen von allen Elementen
  $(".last-stickiest-section-item").removeClass("last-stickiest-section-item");
  $(".first-li-after-stickiest-section").removeClass("first-li-after-stickiest-section");

  consecutive_elements.forEach((element, index) => {
    if (typeof sortKey === 'undefined' || sortKey === null) {
      section_affected = true;
      $(element).addClass(stickiest_section_class);
      if (index === consecutive_elements.length - 1) {
        $(element).addClass("last-stickiest-section-item");
        $(element).next().addClass("first-li-after-stickiest-section");
      }
    }
  });

  return section_affected ? consecutive_elements : [];
};

const handle_all_sticky_sections = function(){
  let has_stickiest = reset_stickiest_section('Stickiest-stickiestItem Stickiest-tagStickyItem');
  //console.info("has_stickiest", has_stickiest)
  //if(!has_stickiest || has_stickiest.length === 0) {
  //  let has_tag_sticky = reset_stickiest_section('Stickiest-stickiestItem Stickiest-tagStickyItem');
  //  //console.info("has_tag_sticky", has_tag_sticky)
  //}
};



app.initializers.add('maisen20-extend-stickiest-get-sortorder', () => {
    extend(DiscussionList.prototype, 'oncreate', function() {
        const state = this.attrs.state; 
        if (state) {
            // Der aktuelle Sortierschlüssel und die Richtung
            sortKey = state.params.sort;
        }
        handle_all_sticky_sections();
    });
});

/*
app.initializers.add('maisen20-extend-stickiest', () => {
    extend(DiscussionListItem.prototype, 'oncreate', function() {
        handle_all_sticky_sections();
    });

    extend(DiscussionListItem.prototype, 'onupdate', function() {
        handle_all_sticky_sections();
    });
});

*/



app.initializers.add('maisen20-extend-stickiest', (app) => {
    extend(DiscussionList.prototype, 'oncreate', function() {
        // Prüfe, ob der Observer bereits eingerichtet wurde
        if (this.observerInitialized) return;
        this.observerInitialized = true; // Setze Flag, dass der Observer eingerichtet wird

        const setupObserver = () => {
            const contentContainer = document.querySelector('#content');
            if (!contentContainer || contentContainer.dataset.observerSetup) return;

            contentContainer.dataset.observerSetup = 'maisen20-extend-stickiest'; // Kennung für den Observer
            const observer = new MutationObserver((mutations) => {
              mutations.forEach(mutation => {
                  if (mutation.addedNodes.length) {
                      mutation.addedNodes.forEach(node => {
                          if (node instanceof HTMLElement && (node.matches('.DiscussionListItem') || node.querySelector('.DiscussionListItem'))) {
                              handle_all_sticky_sections();
                          }
                      });
                  }
              });
            });

            observer.observe(contentContainer, { childList: true, subtree: true });

            m.redraw.onremove = function() {
                observer.disconnect();
                contentContainer.dataset.observerSetup = ''; // Entferne Kennzeichnung beim Entfernen der Komponente
            };
        };

        setupObserver();

        const mainObserver = new MutationObserver(mutations => {
            mutations.forEach(mutation => {
                if (mutation.addedNodes.length) {
                    mutation.addedNodes.forEach(node => {
                        if (node instanceof HTMLElement && node.matches('#content') && !node.dataset.observerSetup) {
                            setupObserver(); // Setze den Observer neu auf, falls #content neu erstellt wird
                        }
                    });
                }
            });
        });

        mainObserver.observe(document.body, { childList: true, subtree: true });
    });
});
